import { render, staticRenderFns } from "./planning-app.vue?vue&type=template&id=1ddd68e6"
import script from "./planning-app.ts?vue&type=script&lang=ts&external"
export * from "./planning-app.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports